import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";
import { CarePlan } from "../../../utility/interfaces/carePlanInterfaces";

const patientPlanApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPatientPlan: builder.query<
      CarePlan,
      { patientId: number; patientPreferredLang: string }
    >({
      query: (patient: { patientId: number; patientPreferredLang: string }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = patient.patientPreferredLang;
        return {
          url: `/api/v1/Patient/${patient.patientId}/patient-plan`,
          method: "GET",
          headers,
        };
      },
      providesTags: (result, error, { patientId }) => [
        { type: "CarePlanDetails", id: patientId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetPatientPlanQuery } = patientPlanApi;
export default patientPlanApi;
